import CryptoJS from 'crypto-js';
export default [
    {
        name: 'revicionoic',
        path: '/revicionoic/:id_certificado/:id_cafe_solicitud',
        component: () => import(/* webpackChunkName: "FormCafe" */ '../components/revision/FormCafe.vue'),
        props: (route) => {
            const { id_certificado, id_cafe_solicitud } = route.params
            
            let eg1 = id_certificado.replace(/p1L2u3S/g, '+').replace(/s1L2a3S4h/g, '/').replace(/e1Q2u3A4l/g, '=')
            eg1 = CryptoJS.AES.decrypt(eg1, process.env.SECURITY_KEY).toString(CryptoJS.enc.Utf8)            
            let id_certificado_decry = parseInt(eg1)
            
            var eg4 = id_cafe_solicitud.replace(/p1L2u3S/g, '+').replace(/s1L2a3S4h/g, '/').replace(/e1Q2u3A4l/g, '=')
            eg4 = CryptoJS.AES.decrypt(eg4, process.env.SECURITY_KEY).toString(CryptoJS.enc.Utf8)
            let id_cafe_solicitud_decry = parseInt(eg4)

            return { id_certificado: id_certificado_decry, id_cafe_solicitud: id_cafe_solicitud_decry }
        },
        meta: {
            title: 'Formulario OIC',
            middleware: 'auth',
            middlewareRol: ['Certificador', 'Responsable', 'Asistente', 'Representante Legal', 'Registrar y Firmar Trámites'],
            middlewareEmpresa: ['Institución Revisora/Certificadora', 'Empresa con RUEX']
        }
    },

    {
        name: 'pendienteOic',
        path: '/pendientecafe',
        component: () => import(/* webpackChunkName: "Pendientes" */  '../components/revision/Pendientes.vue'),
        meta: {
            title: 'Pendientes',
            middleware: 'auth',
            middlewareRol: ['Certificador', 'Responsable', 'Asistente'],
            middlewareEmpresa: ['Institución Revisora/Certificadora']
        }
    },

    {
        name: 'formfirmacertificado',
        path: '/formfirmacertificado/:id_certificado',
        component: () => import(/* webpackChunkName: "FormFirmaOic" */ '../components/revision/FormFirma.vue'),
        props: (route) => {
            const { id_certificado} = route.params
            
            let eg1 = id_certificado.replace(/p1L2u3S/g, '+').replace(/s1L2a3S4h/g, '/').replace(/e1Q2u3A4l/g, '=')
            eg1 = CryptoJS.AES.decrypt(eg1, process.env.SECURITY_KEY).toString(CryptoJS.enc.Utf8)            
            let id_certificado_decry = parseInt(eg1)

            return { id_certificado: id_certificado_decry }
        },
        meta: {
            title: 'Firma OIC',
            middleware: 'auth',
            middlewareRol: ['Certificador', 'Responsable', 'Asistente', 'Representante Legal', 'Registrar y Firmar Trámites'],
            middlewareEmpresa: ['Institución Revisora/Certificadora', 'Empresa con RUEX']
        }
    },
]